<script setup lang="ts">
import { ref } from 'vue'

const email = ref('')
const status = ref<'idle' | 'success' | 'error'>('idle')

const subscribe = async (e: Event) => {
  if (!email.value) return
  
  const form = e.target as HTMLFormElement
  const formData = new FormData()
  formData.append('form-name', 'newsletter')
  formData.append('email', email.value)
  
  try {
    await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData as any).toString()
    })
    
    status.value = 'success'
    email.value = ''
    setTimeout(() => {
      status.value = 'idle'
    }, 3000)
  } catch (error) {
    console.error('Error:', error)
    status.value = 'error'
  }
}
</script>

<template>
  <section class="newsletter">
    <div class="container">
      <h2>Stay Updated</h2>
      <p>Subscribe to our newsletter for the latest news and exclusive offers.</p>
      
      <form 
        name="newsletter" 
        method="POST" 
        data-netlify="true"
        @submit.prevent="subscribe" 
        class="newsletter-form"
      >
        <input type="hidden" name="form-name" value="newsletter" />
        <input type="hidden" name="bot-field" />
        <input 
          type="email" 
          v-model="email" 
          name="email"
          placeholder="Enter your email"
          required
        >
        <button type="submit" class="btn">Subscribe</button>
      </form>
      
      <p v-if="status === 'success'" class="success-message">
        Thank you for subscribing! 🎉
      </p>
    </div>
  </section>
</template>

<style scoped>
.newsletter {
  background: rgba(36, 123, 160, 0.05);
  padding: 4rem 0;
  text-align: center;
}

.newsletter h2 {
  margin-bottom: 1rem;
  font-size: 2.5rem;
}

.newsletter p {
  margin-bottom: 2rem;
  color: var(--secondary);
}

.newsletter-form {
  display: flex;
  gap: 1rem;
  max-width: 500px;
  margin: 0 auto;
}

.newsletter-form input {
  flex: 1;
  padding: 1rem;
  border: 1px solid rgba(227, 20, 71, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: var(--text);
}

.success-message {
  color: #4CAF50 !important;
  margin-top: 1rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>